// 上报方式枚举
export const accessTypeList = [
  { value: "ACCESS_TYPE_SDK", label: "SDK上报" },
  { value: "ACCESS_TYPE_API", label: "API上报" },
  { value: "ACCESS_TYPE_JS", label: "JS上报" },
];
// 归因方式枚举
export const claimTypeList = [
  { value: "CLAIM_TYPE_ACTIVATION", label: "激活归因" },
  { value: "CLAIM_TYPE_CLICK", label: "点击归因" },
  { value: "CLAIM_TYPE_REGISTER", label: "注册归因" },
  { value: "CLAIM_TYPE_IMPRESSION", label: "曝光归因" },
];
// 接入状态枚举
export const accessStatusList = [
  { value: "ACCESS_STATUS_COMPLETED", label: "已接入" },
  { value: "ACCESS_STATUS_PENDING", label: "待接入" },
];

// 广告深度优化转化目标类型
export const goalRoiList = [
  { value: "GOAL_NONE", label: "初始值" },
  { value: "GOAL_7DAY_PURCHASE_ROAS", label: "7 天付费ROI" },
  { value: "GOAL_15DAY_PURCHASE_ROAS", label: "15 天付费ROI" },
  { value: "GOAL_30DAY_PURCHASE_ROAS", label: "30 天付费ROI" },
  { value: "GOAL_60DAY_PURCHASE_ROAS", label: "60 天付费ROI" },
  { value: "GOAL_30DAY_MONETIZATION_ROAS", label: "30 天变现ROI" },
  { value: "GOAL_30DAY_ORDER_ROAS", label: "下单ROI" },
  { value: "GOAL_1DAY_PURCHASE_ROAS", label: "首日付费ROI" },
  { value: "GOAL_1DAY_MONETIZATION_ROAS", label: "首日变现ROI" },
  { value: "GOAL_3DAY_PURCHASE_ROAS", label: "3 日付费ROI" },
  { value: "GOAL_3DAY_MONETIZATION_ROAS", label: "3 日变现ROI" },
  { value: "GOAL_7DAY_MONETIZATION_ROAS", label: "7 日变现ROI" },
  { value: "GOAL_15DAY_MONETIZATION_ROAS", label: "15 日变现ROI" },
];
